import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ScrollToTopProps } from './types';

const ScrollToTop: React.FC<ScrollToTopProps> = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return <>{children}</>;
};

export default ScrollToTop;
